import type { FC } from 'react';
import { MODALS } from '@constants/index';
import { useModalDispatch } from '@hooks/useModalProvider';
import type { SubmissionShort } from '@queries/fetchSubmissions';

import { type ContractOption, ContractOptionId } from '../types';
import { CreateContractButton } from '../views/CreateContractButton';
interface CreateContractButtonControllerPaginationProps {
  contracts: SubmissionShort[];
}

interface CreateContractButtonControllerInfiniteScrollProps {
  hasFinalisedContracts: boolean;
}

export const CreateContractButtonController: FC<
  CreateContractButtonControllerPaginationProps | CreateContractButtonControllerInfiniteScrollProps
> = (props: CreateContractButtonControllerPaginationProps | CreateContractButtonControllerInfiniteScrollProps) => {
  const { showModal } = useModalDispatch();

  const handleOptionSelect = (option: ContractOption) => {
    if (option.id === ContractOptionId.CONTRACT) {
      showModal(MODALS.ADMIN_CREATE_TEMPLATE, {});
    }

    if (option.id === ContractOptionId.ENDORSEMENT) {
      showModal(MODALS.CREATE_ENDORSEMENT, { isStandalone: true });
    }

    if (option.id === ContractOptionId.RENEWAL) {
      showModal(MODALS.CREATE_RENEWAL, { isStandalone: true });
    }
  };

  let hasFinalisedContracts = false;
  if ('contracts' in props) {
    hasFinalisedContracts = props.contracts.some((contract) => contract.status === 'FINAL');
  } else {
    hasFinalisedContracts = props.hasFinalisedContracts;
  }

  return <CreateContractButton onSelect={handleOptionSelect} hasFinalisedContracts={hasFinalisedContracts} />;
};
